import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import 'rxjs/add/operator/toPromise';
import 'hammerjs';

import { TrackerService } from './services/tracker.service';
import { ParticipantService } from './services/participant.service';
import { GymService } from './services/gym.service';
import { ExerciseService } from './services/exercise.service';
import { ActivityService } from './services/activity.service';
import { ClassTemplateService } from './services/class-template.service';
import { GroupClassService } from './services/group-class.service';
import { AssetsService } from './services/assets.service';
import { UserService } from './services/user.service';
import { LoginService } from './services/login.service';
import { AppSettings } from './providers/app-settings';

import { MenuComponent } from './components/menu/menu.component';
import { TrackerComponent } from './components/tracker/tracker.component';
import { TrackerPairComponent } from './components/tracker-pair/tracker-pair.component';
import { GymComponent } from './components/gym/gym.component';
import { ExerciseComponent } from './components/exercise/exercise.component';
import { ActivityComponent } from './components/activity/activity.component';
import { ClassTemplateComponent } from './components/class-template/class-template.component';
import { GroupClassComponent } from './components/group-class/group-class.component';
import { AssetsComponent } from './components/assets/assets.component';
import { UserComponent } from './components/user/user.component';
import { LoginComponent } from './components/login/login.component';
import { WindowRef } from './providers/window-ref';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AddGymToClassTemplatesComponent } from './components/add-gym-to-class-templates/add-gym-to-class-templates.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/**
 * Material modules
 */
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
} from '@angular/material';

/**
 * Pipes
 */
import {KeysPipe} from './pipes/keys.pipe';
import { DisplayErrorComponent } from './components/display-error/display-error.component';

const appRoutes: Routes = [
  { path: 'tracker', component: TrackerComponent },
  { path: 'trackerPair', component: TrackerPairComponent },
  { path: 'exercise', component: ExerciseComponent },
  { path: 'activity', component: ActivityComponent },
  { path: 'gym', component: GymComponent },
  { path: 'classTemplate', component: ClassTemplateComponent },
  { path: 'groupClass', component: GroupClassComponent },
  { path: 'assets', component: AssetsComponent },
  { path: 'user', component: UserComponent },
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: 'gym', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    TrackerComponent,
    TrackerPairComponent,
    GymComponent,
    ExerciseComponent,
    ActivityComponent,
    ClassTemplateComponent,
    GroupClassComponent,
    AssetsComponent,
    UserComponent,
    LoginComponent,
    AddGymToClassTemplatesComponent,
    NotFoundComponent,
    KeysPipe,
    DisplayErrorComponent,
  ],
  entryComponents: [
    AddGymToClassTemplatesComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false }
    ),
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
  ],
  providers: [
    TrackerService,
    ParticipantService,
    GymService,
    ExerciseService,
    ActivityService,
    ClassTemplateService,
    GroupClassService,
    AssetsService,
    UserService,
    LoginService,
    AppSettings,
    WindowRef
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.module.ts